// src/services/firebase.ts
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyAgIlUAiYbLJoDh0iXlXiQov6uXhLFyIfs",
  authDomain: "behavoranalyst-38483.firebaseapp.com",
  projectId: "behavoranalyst-38483",
  storageBucket: "behavoranalyst-38483.appspot.com",
  messagingSenderId: "221274221554",
  appId: "1:221274221554:web:45c340eeab16866480596b",
  measurementId: "G-8ZLFS7CDS2"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

// הגדרת Google provider עם הגדרות מתקדמות
const provider = new GoogleAuthProvider();
provider.addScope('email');
provider.addScope('profile');

// הגדרות נוספות למניעת שגיאות popup
provider.setCustomParameters({
  prompt: 'select_account'
});

export { auth, provider };
